export const PAYMENT_ERROR_MESSAGE_KEY = {
  INVALID_API_KEY: 'error_saved_card',
  FORBIDDEN_REQUEST: 'error_saved_card',
  INVALID_REQUEST: 'error_saved_card',
  INVALID_ACCESS_TOKEN: 'error_saved_card',
  INVALID_CARD_NUMBER: 'error_card_number',
  INVALID_CARD_EXPIRATION: 'error_card_details',
  INVALID_CARD_INFO_RE_REGISTER: 'error_card_valid',
  INVALID_REJECT_CARD: 'error_card_declined',
  REJECT_CARD_PAYMENT: 'error_card_complete',
  NOT_FOUND_METHOD: 'error_saved_card',
  NOT_SUPPORTED_METHOD: 'error_saved_card',
  NOT_FOUND_CUSTOMER: 'error_saved_card',
  FAILED_PAYMENT_INTERNAL_SYSTEM_PROCESSING: 'error_card_maintenance',
  FAILED_PAYMENT_CONFIRM: 'error_card_maintenance',
  REJECT_CARD_COMPANY: 'error_card_maintenance',
  FAILED_CARD_COMPANY: 'error_card_maintenance_1',
  UNKNOWN_PAYMENT_ERROR: 'error_card_approval',
  DUPLICATED_ORDER_ID: 'error_card_approval',
  MAINTAINED_METHOD: 'error_card_maintenance_2',
  FAILED_SYSTEM_CHECK_TIME: 'error_card_maintenance_3',
  PROVIDER_ERROR: 'error_card_maintenance_4',
  UNKNOWN_ERROR: 'error_card_maintenance_4',
};

export const MINIMUM_RECHARGE = 10000;
export const MAXIMUM_RECHARGE = 70000;
